// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"Evaluation_infoIcon__HOwM9","container":"Evaluation_container__23_Yq","buttonsContainer":"Evaluation_buttonsContainer__W1KwP"};